import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { WsUserProfileService } from 'src/app/ws/wsUserProfile/ws-user-profile.service';
import { MAddressListRequest, MAddressRequest, MAddressResponseData, MOrderDetailRequest, MUserProfileRequest, MUserProfileResponseData } from 'src/app/pages/user/user.module';
import { lastValueFrom } from 'rxjs';
import { SharedPrefrences } from 'src/app/utils/utils.service';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { WsShopallService } from 'src/app/ws/wsShopAll/ws-shopall.service';
import { CommonBehaviorChangeService } from 'src/app/utils/common-behaviour-service';
import html2canvas from 'html2canvas';
import jspdf from 'jspdf';
import { SpinnerVisibilityService } from 'ng-http-loader';
import moment from 'moment';
import { LoginPopupComponent } from 'src/app/components/login-popup/login-popup.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MAddUpdateCartModule, MAddUpdateCartModuleResponse } from 'src/app/pages/product-detail-updated/product-detail-updated.module';

@Component({
  selector: 'app-my-wishlist',
  templateUrl: './my-wishlist.component.html',
  styleUrls: ['./my-wishlist.component.scss']
})
export class MyWishlistComponent {
  [x: string]: any;

  @ViewChild('pdfTable', { static: false }) pdfTable!: ElementRef;



  id: any;
  mUserProfileReq: MUserProfileRequest = new MUserProfileRequest();
  mUserProfileData: MUserProfileResponseData = new MUserProfileResponseData();
  mAddressListReq: MAddressListRequest = new MAddressListRequest();
  mAddressListData: any
  mOrderReq: MOrderDetailRequest = new MOrderDetailRequest();
  mAddressReq: MAddressRequest = new MAddressRequest();
  mAddressResponseData?: MAddressResponseData;
  mOrderDetailListData: any;
  mWishlistData: any = [];
  addressFormgroup!: FormGroup;
  viewForm: any = '';
  addressData: any;
  orderForm = false;
  mOrderDetail: any;
  mAddUpdateCartModuleResponse: any = new MAddUpdateCartModuleResponse()
  mAddUpdateCartModule: MAddUpdateCartModule = new MAddUpdateCartModule()
  constructor(private spinner: SpinnerVisibilityService, private modalService: NgbModal, private _commonBehaviorChangeService: CommonBehaviorChangeService, private wsUserProfileService: WsUserProfileService, private router: Router, private wsShopAllService: WsShopallService) {
    this._commonBehaviorChangeService.currentrCartList.subscribe((cartList: any) => {
      this.mAddUpdateCartModuleResponse.data = cartList.data;
    })
    
    this._commonBehaviorChangeService.currentWishList.subscribe((wishList: any) => {
      this.mWishlistData = wishList;
      
      this.mWishlistData && this.mWishlistData.length > 0 && this.mWishlistData.forEach((product: any) => {
        const cartPresent = this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product['productdetail'].id && el.qty > 0) });
        if (cartPresent.length > 0) {
          product['productdetail'].cartQty = cartPresent[0].qty;
        }
      })
    })
  }

  downloadAsPDF() {
    this.spinner.show()
    const doc = new jspdf("p", "mm", "a4");

    // Define options for html2canvas
    const options = {
      scale: 2 // Adjust the scale factor as needed for better quality
    };
    const element: any = document.getElementById('pdfTable');
    $('#pdfTable').removeAttr('hidden')
    // Convert HTML to canvas using html2canvas
    html2canvas(element, options).then(canvas => {
      // Get the width and height of the canvas
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;

      // Calculate the page width and height based on the aspect ratio
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = canvasHeight * (pageWidth / canvasWidth);

      // Add the canvas to the PDF document
      const imageData = canvas.toDataURL('image/png', 1);
      doc.addImage(imageData, 'PNG', 0, 0, pageWidth, pageHeight);

      // Save the PDF document
      doc.save('output.pdf');
      this.spinner.hide()
      // element.style.display = 'none'
      $('#pdfTable').attr('hidden', 'true')
    });
  }

  savedAddress(index: any) {
    $(".address-hide-content-" + index).slideToggle();
  }

  itemDeliveredProcess(mOrderData: any) {
    this.orderForm = true;
    this.mOrderDetail = mOrderData
  }

  orderDetail() {
    this.orderForm = false;
  }

  showDate(val: any) {
    return moment(val).format('MMM , DD YYYY');
  }

  orderProcess() {
    $(".process-arrow img").toggleClass("arrow-rotate");
    $(".order-process").toggleClass("process-show");
  }

  ngOnInit() {
    this.id = SharedPrefrences.getUserId();

    this.mUserProfileReq.id = this.id
    this.getUserPofile(this.mUserProfileReq)

    this.mAddressListReq.userId = this.id
    this.getAddressList(this.mAddressListReq)

    this.mOrderReq.take = 10;
    this.mOrderReq.skip = 0;
    this.mOrderReq.search = "odr.user_id = '" + this.id + "'";
    this.getOrderDetaiList(this.mOrderReq);

    this.getWishList(this.id);
    this.getAllCartProducts();
    if (localStorage.getItem('orderType') == 'order') {
      $('#order-tab').trigger('click')
      localStorage.setItem('orderType', '')
    }
  }

  getQuantityCount(orderDetail: any) {

  }

  /**
  * Date:- 13-06-2023
  * Method :- This method is used to Set Address Details In Edit Form
  */
  addUpdateAddress(val: any, address?: MAddressResponseData) {
    this.addressData = address;
    this.viewForm = val;
  }

  /**
  * Date:- 13-06-2023
  * Method :- This method is used to Get User Profile Details
  * @param id :-  This param is used for request to Get Profile Details
  */
  async getUserPofile(id: MUserProfileRequest) {
    const userProfile = this.wsUserProfileService.getUserProfile(id)
    await lastValueFrom(userProfile).then(async response => {
      if (response && response.statusCode == 200) {
        this.mUserProfileData = response.data
      }
    })
  }

  /**
  * Date:- 13-06-2023
  * Method :- This method is used to Get Address List
  * @param userId :-  This param is used for request to Get Address List
  */
  async getAddressList(userId: MAddressListRequest) {
    const addressList = this.wsUserProfileService.getAddressList(userId)
    await lastValueFrom(addressList).then(async response => {
      if (response && response.statusCode == 200) {
        this.mAddressListData = response.data
      }
    })
  }

  /**
  * Date:- 13-06-2023
  * Method :- This method is used to Remove Address
  * @param addressId :-  This param is used for Remove Address
  */
  async removeAddress(addressId: any) {
    const removeAddress = this.wsUserProfileService.removeAddress(addressId)
    await lastValueFrom(removeAddress).then(async response => {
      if (response && response.statusCode == 200) {
        this.mAddressListReq.userId = this.id
        this.getAddressList(this.mAddressListReq)
      }
    })
  }

  /**
  * Date:- 14-06-2023
  * Method :- This method is used to Get Order Detail List
  * @param searchId :-  This param is used for request to Get Order Detail List
  */
  async getOrderDetaiList(search: MOrderDetailRequest) {
    const orderList = this.wsUserProfileService.getOrderDetailList(search)
    await lastValueFrom(orderList).then(async response => {
      if (response && response.statusCode == 200) {
        this.mOrderDetailListData = response.data
      }
    })
  }

  /**
  * Date:- 21-06-2023
  * Method :- This method is used to Get Order Detail List
  * @param userId :-  This param is used for request to Get Order Detail List
  */
  async getWishList(userId: string) {
    const wishList = this.wsUserProfileService.getWishList(userId)
    await lastValueFrom(wishList).then(async response => {
      if (response && response.statusCode == 200) {
        this.mWishlistData = response.data
      }
    })
  }

  /**
  * Date: 10-06-23
  * Method : This method is used to get all cart items 
  */
  async getAllCartProducts() {
    const getAllCart = this.wsShopAllService.getCartList("" + SharedPrefrences.getUserId())
    await lastValueFrom(getAllCart).then(async response => {
      if (response && response.statusCode == 200) {
        this.mAddUpdateCartModuleResponse.data = response.data;
      } else {
      }
    })
  }

  async addToCartCommon(product: any, type?: any, index?: any, productType?: any) {
    this.mAddUpdateCartModule.user_id = "" + SharedPrefrences.getUserId();
    if (type == 'cart') {
      this.mAddUpdateCartModule.iswishlistitem = false;
    } else {
      this.mAddUpdateCartModule.iswishlistitem = true;
    }
    this.mAddUpdateCartModule.product_id = product.id;
    if (type == "cart") {
      const cart = this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.findIndex((cart: any) => { return cart.product_id === product.id })
      if (cart > -1) {
        this.mAddUpdateCartModule.qty = this.mAddUpdateCartModuleResponse.data[cart].qty + 1;
        this.mAddUpdateCartModule.id = this.mAddUpdateCartModuleResponse.data[cart].id;
      } else {
        this.mAddUpdateCartModule.qty = 1;
      }
      const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
      await lastValueFrom(addRemoveProductFromCart).then(async response => {
        if (response && response.statusCode == 200) {
          this._commonBehaviorChangeService.addCart(true);
        } else {
          console.log("something went wrong")
        }
      })
    } else {
      const wishlist = this.mWishlistData && this.mWishlistData.findIndex((wishlist: any) => { return wishlist.product_id === product.id })
      if (wishlist > -1) {
        this.mAddUpdateCartModule.id = this.mWishlistData[wishlist].id;
      }
      this.mAddUpdateCartModule.qty = 0;
      const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
      await lastValueFrom(addRemoveProductFromCart).then(async response => {
        if (response && response.statusCode == 200) {
          this._commonBehaviorChangeService.addWishlist(true)
          if (productType == 'wishList') {
            this.mWishlistData.splice(index, 1)
          }
          this._commonBehaviorChangeService.addWishlist(true)
        } else {
          console.log("something went wrong")
        }
      })
    }
  }

  saveNewAddress() {
    this.mAddressListReq.userId = this.id
    this.getAddressList(this.mAddressListReq)
  }


  showProduct(product: any) {
    var productName = product.name.split(' ').join('_').replace(',', '')
    this.router.navigate(["/product-detail-updated/" + product.id + '/' + productName.replace(/[&\/\#,+()$~%.'":*?<>{}]/g,'_')])
  }

  async getBase64ImageFromUrl(imageUrl: string, callback: any) {
    var res = await fetch(imageUrl);
    var blob = await res.blob();
    var reader = new FileReader();
    reader.onloadend = function () {
      callback(reader.result);
    }
    reader.readAsDataURL(blob);
  }
  toDataURL(url: string, callback: any) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      }
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  }
  getImageBase64(url: string) {
    this.getBase64ImageFromUrl(url, (result: string) => {
      return result;
    })
  }

  buyNowCommon(product: any) {
    const productDetail = {
      qty: 1,
      productId: product.id
    }
    localStorage.setItem("buynow", JSON.stringify(productDetail))
    const userAgent = window.navigator.userAgent.toLowerCase();
    var mobile = /iphone|ipad|ipod|android|blackberry|iemobile|opera mini/i.test(userAgent)
    if(mobile){
      this.router.navigate(["/checkout-new-mob/buynow/" + product.id])
    }else{
      this.router.navigate(["/checkout-new/buynow/" + product.id])
    }
  }

  buyNow(product: any) {
    if (SharedPrefrences.getUserId() != null && SharedPrefrences.getUserId() != '') {
      this.buyNowCommon(product)
    } else {
      const modalRef = this.modalService.open(LoginPopupComponent);
      modalRef.componentInstance.type = 1;
      modalRef.componentInstance.emitService.subscribe((emmitedValue: any) => {
        if (emmitedValue) {
          this.buyNowCommon(product)
        }
      })
    }
  }

  backClick() {
    this.router.navigate(['/user/' + this.id]);
  }
}
